




























































































































































































































































































import { Component, Vue } from 'vue-property-decorator';


import { Device, Info } from '@/types/core';
import { DateTime } from 'luxon';
import { curCoreClient, CoreClient } from '@/services/CoreClient';
import { SubUtil } from '@/util/SubUtil';

import GroupAccessEdit from '@/components/access/GroupAccessEdit.vue';
import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import {
  HttpEndpoint,
  SnsEndpoint,
  KinesisEndpoint,
  UbidotsEndpoint,
  IotCoreEndpoint,
  AzureEventHubEndpoint, MqttEndpoint
} from '@/types/core-push';

@Component({
  components: {
    Loading,
    VueError,
    SectionHeader,
    Success,
    GroupAccessEdit
  },
})
export default class CreateSub extends Vue {

  // our model
  info:Info = {} as Info;
  error:string = '';
  success:string = '';
  
  // our model
  enterpriseId:string = "";
  type:string = "http";
  httpUrl:string = "";
  httpHeaderText:string = "";
  snsAccessKeyId:string = "";
  snsSecretAccessKey:string = "";
  snsRegion:string = "";
  snsTopicArn:string = "";
  kinesisAccessKeyId:string = "";
  kinesisSecretAccessKey:string = "";
  kinesisRegion:string = "";
  kinesisStreamName:string = "";
  azureEventHubConnectionString = "";
  azureEventHubName = "";
  ubidotsIngestDomain:string = 'industrial.api.ubidots.com';
  ubidotsToken:string = '';

  iotCoreEndpointUrl:string = "";
  iotCoreAccessKeyId:string = "";
  iotCoreSecretAccessKey:string = "";
  iotCoreRegion:string = "";
  iotCoreTopicPrefix:string = "/n2n/v3/devices"
  iotCoreTopicSuffix:string = "uplinks"

  deviceType:string = "";
  pushInterval: number = 10;
  cascade: boolean = false;
  format: string = 'json';
  groupIdList: string[] = [];

  httpBusy:boolean = false;

  dirtyList:string[] = [];

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;
  private subUtil:SubUtil = new SubUtil();
  
  async mounted() {

    const reply = await this.coreClient.getInfo();
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve user info: ${reply.errorMsg}`;
    
    // we update the state
    this.info = reply.info as Info;
  }

  get entList():object[] {

    if(!this.info.level)
      return [];

    return this.subUtil.groupListToEntList(this.info.fullGroupIdList);
  }


  // http endpoint
  get httpEndpoint():HttpEndpoint {

    let headerList = this.httpHeaderText.split('\n')
      .filter(header => header !== "")
      .map(header => header.trim())

    return {
      url:this.httpUrl,
      headerList: headerList.length > 0 ? headerList : undefined
    }
  }

  // sns endpoint
  get snsEndpoint():SnsEndpoint {
    return {
      accessKeyId: this.snsAccessKeyId,
      secretAccessKey: this.snsSecretAccessKey,
      region: this.snsRegion,
      topicArn: this.snsTopicArn
    }
  }

  // Kinesis endpoint
  get kinesisEndpoint():KinesisEndpoint {
    return {
      accessKeyId: this.kinesisAccessKeyId,
      secretAccessKey: this.kinesisSecretAccessKey,
      region: this.kinesisRegion,
      streamName: this.kinesisStreamName
    }
  }

  get azureEventHubEndpoint():AzureEventHubEndpoint {
    return {
      connectionString: this.azureEventHubConnectionString,
      eventHubName: this.azureEventHubName,
    }
  }

  get mqttEndpoint():MqttEndpoint {
    return {}
  }

  // Ubidots endpoint
  get ubidotsEndpoint():UbidotsEndpoint {
    return {
      ingestDomain: this.ubidotsIngestDomain,
      token: this.ubidotsToken
    }
  }

  // Iot Core endpoint
  get iotCoreEndpoint():IotCoreEndpoint {
    return {
      endpointUrl: this.iotCoreEndpointUrl,
      accessKeyId: this.iotCoreAccessKeyId,
      secretAccessKey: this.iotCoreSecretAccessKey,
      region: this.iotCoreRegion,
      topicPrefix: this.iotCoreTopicPrefix,
      topicSuffix: this.iotCoreTopicSuffix
    }
  }

  get possibleGroupIdList():Array<{groupId:string, displayName:string}> {

    if(this.enterpriseId === "")
      return [];

    let masterGroup = `${this.enterpriseId}.master`;
    let masterGroupDepth = masterGroup.split('.').length;

    let ret = this.info.fullGroupIdList
      .filter(groupId => groupId.startsWith(`${this.enterpriseId}.`))
      .filter(groupId => !groupId.endsWith(`.master`))
      .filter(groupId => groupId.split('.').length === masterGroupDepth)
      .map(groupId => ({groupId:groupId, displayName:groupId.substring(this.enterpriseId.length + 1)}))
    
    return ret;
  }

  get deviceTypeList():string[] {

    if (this.info){
      return this.info.deviceTypes.sort()
    }
    return []
  }
  
  get canCreateSub():boolean {
    return !this.httpBusy
  }

  async doCreateSub() {

    this.httpBusy = true;
    this.error = '';

    let endpoint:HttpEndpoint|SnsEndpoint|KinesisEndpoint|IotCoreEndpoint|UbidotsEndpoint|AzureEventHubEndpoint|MqttEndpoint;

    switch(this.type) {
      case 'http': endpoint = this.httpEndpoint; break;
      case 'sns': endpoint = this.snsEndpoint; break;
      case 'kinesis': endpoint = this.kinesisEndpoint; break;
      case 'iotCore': endpoint = this.iotCoreEndpoint; break;
      case 'azureEventHub': endpoint = this.azureEventHubEndpoint; break;
      case 'ubidots': 
        endpoint = this.ubidotsEndpoint; 
        this.format = 'json';
        break;
      case 'mqtt':
        endpoint = this.mqttEndpoint;
        break;
      default:
        return this.error = `internal error: unrecognised type '${this.type}'`;
    }

    let sub = {
      enterpriseId: this.enterpriseId,
      type: this.type,
      endpoint: endpoint,
      deviceType: this.deviceType !== "" ? this.deviceType : undefined,
      groupIdList: this.groupIdList.length > 0 ? this.groupIdList : undefined,
      pushInterval: this.pushInterval,
      cascade: this.cascade,
      format: 'json'
    }

    const reply = await this.coreClient.createSub(sub);

    this.httpBusy = false;
    
    if(reply.errorMsg)
      return this.error = `unable to create subscription: ${reply.errorMsg}`;

    this.setSuccess(`subscription ${reply.newSub!.subscriptionId} created successfully`);
    
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
